module.exports = __webpack_public_path__ + "../../dist/Messanger/img/info.46e0f776.svg";